import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';

export const ConsultaBecasSolici = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ConsultaBecasSolici`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultaEstBecados = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ConsultaEstBecados`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultEstBecadoInd = (ci, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            ci: ci
        }

        Post(`${Url}ConsultEstBecadoInd`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const AddEstBecado = (ci, uc, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            ci: ci,
            uc: uc,
            tipo: tipo
        }

        Post(`${Url}AddEstBecado`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const ConsultPreferencias = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ConsultPreferenciasG`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultaDatAcademicos = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}ConsultaDatAcademicos`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultaUcInscritos = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}ConsultaUcInscritos`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}


export const ConsultHistorico = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}ConsultHistorico`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const NapBeca = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }

        Post(`${Url}NapBeca`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const ApBeca = (est, uc, ucName, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            uc: uc,
            ucName: ucName
        }

        Post(`${Url}ApBeca`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}



// WEBPACK FOOTER //
// ./src/funciones/BecasFunction.jsx